import mechanicTypes from '../mechanic-types';
import RefData from '../../../ref-data';
/**
 * Should we enforce items like INSIGHTS not being defined here because they are determined by permissions?
 * Should there be separate base configs for micro and macro experiences?
 */
export default {
  /**
   * Array of publishing format IDs that determines which types of channels are supported by this workspace
   * RefData.Enum.TYPE.DISPLAYCONTAINER_*
   */
  publishFormatTypeIds: [
    RefData.Enum.TYPE.DISPLAYCONTAINER_TWITTER.STORY,
    RefData.Enum.TYPE.DISPLAYCONTAINER_FACEBOOK.STORY,
    RefData.Enum.TYPE.DISPLAYCONTAINER_SNAPCHAT.STORY,
    RefData.Enum.TYPE.DISPLAYCONTAINER_INSTAGRAM.STORY,
    RefData.Enum.TYPE.DISPLAYCONTAINER_WEB.EMBED,
    RefData.Enum.TYPE.DISPLAYCONTAINER_WEB.OVERLAY,
    RefData.Enum.TYPE.DISPLAYCONTAINER_WEB.MICROSITE,
  ],

  mechanics: {
    [mechanicTypes.ENTRIES]: {
      isSupported:            false,
      /**
       *  Array of strategy ids that ______
       *  RefData.Enum.STRATEGY.CAMPAIGNENTRY.*
       */
      entrySourceStrategyIds: [],
    },
    [mechanicTypes.INSIGHTS]: {
      isSupported: true,
    },
    /**
     * Some experience types do not support rewards. See individual experience configs for details.
     */
    [mechanicTypes.REWARDS]: {
      isSupported: true,
    },
    /**
     * Most of experience types do not support promotions/reveals. See individual experience configs for details.
     */
    [mechanicTypes.PROMOTIONS]: {
      isSupported: false,
    },
  },
};
